"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateEnvArguments = exports.CreateEnvOptions = void 0;
exports.CreateEnvOptions = [
    {
        name: "env",
        questionName: "sourceEnvName",
        type: "string",
        description: "Specifies an existing environment name to copy from.",
        required: true,
    },
];
exports.CreateEnvArguments = [
    {
        name: "name",
        questionName: "newTargetEnvName",
        type: "string",
        description: "Specifies the new environment name.",
        required: true,
    },
];
//# sourceMappingURL=CreateEnvOptions.js.map